import Vue from "vue";
import VueRouter from "vue-router";
import { isLoggedIn } from "@/utils/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: { public: true },
  },
  {
    path: "/",
    component: () => import("@/layouts/AdminLayout.vue"),
    redirect: "/orders",
    children: [
      {
        path: "orders",
        name: "Orders",
        component: () => import("@/views/Orders.vue"),
        meta: { title: "订单管理" },
      },
      {
        path: "refunds",
        name: "Refunds",
        component: () => import("@/views/Refunds.vue"),
        meta: { title: "退款管理" },
      },
      {
        path: "products",
        name: "Products",
        component: () => import("@/views/Products.vue"),
        meta: { title: "商品管理" },
      },
      {
        path: "home-banners",
        name: "HomeBanners",
        component: () => import("@/views/HomeBanners.vue"),
        meta: { title: "商品轮播" },
      },
      {
        path: "categories",
        name: "Categories",
        component: () => import("@/views/Categories.vue"),
        meta: { title: "分类管理" },
      },
      {
        path: "users",
        name: "Users",
        component: () => import("@/views/Users.vue"),
        meta: { title: "用户管理" },
      },
      {
        path: "recharges",
        name: "Recharges",
        component: () => import("@/views/Recharges.vue"),
        meta: { title: "充值管理" },
      },
      {
        path: "stats",
        name: "Stats",
        component: () => import("@/views/Stats.vue"),
        meta: { title: "数据统计" },
      },
      {
        path: "coupons",
        name: "Coupons",
        component: () => import("@/views/Coupons.vue"),
        meta: { title: "优惠券管理" },
      },
      {
        path: "table-codes",
        name: "TableCodes",
        component: () => import("@/views/TableCodes.vue"),
        meta: { title: "桌码管理" },
      },
      {
        path: "settings",
        name: "Settings",
        component: () => import("@/views/Settings.vue"),
        meta: { title: "设置" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    next();
    return;
  }
  if (!isLoggedIn()) {
    next({ path: "/login", query: { redirect: to.fullPath } });
    return;
  }
  next();
});

export default router;
